import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useFormatPolePrice } from 'components/common/hooks/useFormatPolePrice'
import classNames from 'classnames/bind'
import styles from './PriceTimestamps.module.scss'

const cx = classNames.bind(styles)

const DASH = '—'

const PriceTimestamps = ({ polePrice }) => {
  const { formatPolePriceDate } = useFormatPolePrice()
  const { t } = useTranslation()

  const changedAt = formatPolePriceDate(polePrice?.priceAt) || DASH
  const verifiedAt = formatPolePriceDate(polePrice?.priceUpdatedAt) || DASH

  return (
    <div className={cx('timestamp-rows')}>
      <span className={cx('timestamp-label')}>
        {t('widgets.competitorPricing.changedAtLabel')}
      </span>
      <span className={cx('timestamp-value')}>{changedAt}</span>
      <span className={cx('timestamp-label')}>
        {t('widgets.competitorPricing.verifiedAtLabel')}
      </span>
      <span className={cx('timestamp-value')}>{verifiedAt}</span>
    </div>
  )
}

PriceTimestamps.propTypes = {
  polePrice: PropTypes.shape(),
}

PriceTimestamps.defaultProps = {
  polePrice: null,
}

export { PriceTimestamps }
